<template>
  <div>
    <!-- 实时数据 -->
    <div
      style="
        height: 60px;
        border-bottom: 1px solid rgb(204, 204, 204);
        text-align: left;
        line-height: 60px;
        margin-bottom: 20px;
      "
    >
      实时数据 12:00:00 <el-icon><QuestionFilled /></el-icon>
    </div>
    <!-- 关键指标 -->
    <div style="margin-bottom: 20px">
      <div
        style="
          background-color: #f5f7fa;
          border: 1px solid rgb(204, 204, 204);
          height: 40px;
          padding-left: 20px;
          line-height: 40px;
        "
      >
        关键指标
      </div>
      <!-- 四个统计数据 -->
      <div>
        <el-row>
          <el-col :span="6">
            <div class="statistic-card">
              <el-statistic :value="253">
                <template #title>
                  <div style="display: inline-flex; align-items: center">
                    浏览量(PV)
                  </div>
                </template>
              </el-statistic>
              <div class="statistic-footer">
                <div class="footer-item">
                  <span>日</span>
                  <el-icon class="green"><Top /></el-icon>
                  <span> 112.6% </span>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="statistic-card">
              <el-statistic :value="77">
                <template #title>
                  <div style="display: inline-flex; align-items: center">
                    独立用户(UV)
                  </div>
                </template>
              </el-statistic>
              <div class="statistic-footer">
                <div class="footer-item">
                  <span>日</span>
                  <el-icon class="green"><Top /></el-icon>
                  <span> 79.07% </span>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="statistic-card">
              <el-statistic :value="152">
                <template #title>
                  <div style="display: inline-flex; align-items: center">
                    上传次数(VV)
                  </div>
                </template>
              </el-statistic>
              <div class="statistic-footer">
                <div class="footer-item">
                  <span>日</span>
                  <el-icon class="green"><Top /></el-icon>
                  <span> 105.41% </span>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="statistic-card">
              <el-statistic :value="67" suffix="%">
                <template #title>
                  <div style="display: inline-flex; align-items: center">
                    通过率
                  </div>
                </template>
              </el-statistic>
              <div class="statistic-footer">
                <div class="footer-item">
                  <span>日</span>
                  <el-icon class="green"><Top /></el-icon>
                  <span> 52.27% </span>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 地域分布 -->
    <div style="margin-bottom: 20px; width: 100%; height: 500px">
      <div>
        <span
          style="
            display: inline-block;
            padding-left: 10px;
            border-left: 5px solid #555555;
            border-radius: 4px;
          "
          >地域分布</span
        >
      </div>
      <div ref="chartContainer" style="width: 100%; height: 100%"></div>
    </div>
    <!-- 详细数据 -->
    <div>
      <div>
        <span
          style="
            display: inline-block;
            padding-left: 10px;
            border-left: 5px solid #555555;
            border-radius: 4px;
          "
          >详细数据</span
        >
      </div>
      <div>
        <el-table
          :data="tableData"
          stripe
          style="width: 100%; margin-bottom: 10px"
        >
          <el-table-column prop="province" label="省市" />
          <el-table-column prop="PV" label="浏览量PV" />
          <el-table-column prop="UV" label="独立用户UV" />
          <el-table-column prop="examineNum" label="无感水印次数W" />
          <el-table-column prop="passRate" label="通过率" />
          <el-table-column label="历史趋势">
            <template #default>
              <el-button link type="primary" size="small"> 查看 </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="display: flex; justify-content: end">
          <el-pagination
            v-model:current-page="currentPage4"
            v-model:page-size="pageSize4"
            :page-sizes="[10, 20, 50, 100]"
            :size="size"
            :disabled="disabled"
            background
            layout="prev, pager, next,sizes, jumper,total"
            :total="tableData.length"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import * as echarts from "echarts";
import { ref, onMounted } from "vue";
import chinaMapData from "./china.json";
import type { ComponentSize } from "element-plus";
const tableData = [
  {
    province: "广东",
    PV: "66",
    UV: "25",
    examineNum: "39",
    IP: "25",
    passRate: "20.64%",
  },
  {
    province: "上海",
    PV: "66",
    UV: "25",
    examineNum: "39",
    IP: "25",
    passRate: "76.23%",
  },
  {
    province: "江苏",
    PV: "66",
    UV: "25",
    examineNum: "39",
    IP: "25",
    passRate: "10.24%",
  },
  {
    province: "广西",
    PV: "66",
    UV: "25",
    examineNum: "39",
    IP: "25",
    passRate: "8.41%",
  },
  {
    province: "湖北",
    PV: "66",
    UV: "25",
    examineNum: "39",
    IP: "25",
    passRate: "20.64%",
  },
  {
    province: "河北",
    PV: "66",
    UV: "25",
    examineNum: "39",
    IP: "25",
    passRate: "10.24%",
  },
  {
    province: "北京",
    PV: "66",
    UV: "25",
    examineNum: "39",
    IP: "25",
    passRate: "10.24%",
  },
  {
    province: "湖南",
    PV: "66",
    UV: "25",
    examineNum: "39",
    IP: "25",
    passRate: "10.24%",
  },
];
const currentPage4 = ref(1);
const pageSize4 = ref(10);
const disabled = ref(false);
// 地图

const chartContainer = ref(null);
let myChart = null;

onMounted(() => {
  myChart = echarts.init(chartContainer.value);

  // 直接使用import引入的china.json数据
  echarts.registerMap("china", chinaMapData);

  const option = {
    backgroundColor: "transparent",
    // ... 图表配置（保持不变）
    series: [
      {
        type: "map",
        mapType: "china",
        roam: false,
        geoIndex: 0,
        label: {
          normal: {
            show: false,
          },
          emphasis: {
            show: true,
          },
        },
        itemStyle: {
          normal: {
            areaColor: "#ccffcc", // 浅绿色
            // borderColor: "#000", // 边界颜色，如果需要的话
          },
          emphasis: {
            // areaColor: "#ccffcc", // 高亮时的颜色，也可以设置为和默认颜色一样
            color: "black",
            areaColor: "#99ff66",
          },
        },
        data: [
          { name: "上海", value: 10 },
          { name: "广东", value: 100 },
        ],
      },
    ],
  };
  myChart.setOption(option);
});

const size = ref<ComponentSize>("default");
const handleSizeChange = (val: number) => {
  console.log(`${val} items per page`);
};
const handleCurrentChange = (val: number) => {
  console.log(`current page: ${val}`);
};
// 地图
</script>

<style lang="scss" scoped>
.green {
  color: var(--el-color-success);
}
.red {
  color: var(--el-color-error);
}
.statistic-card {
  padding: 20px;
  border: 1px solid #eeeeee;
  border-top: 0;
}
</style>
